import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { CREATE_LOCATION_SECTOR_MUTATION, GET_LOCATION_SECTOR_QUERY, SEARCH_LOCATION_SECTORS_QUERY, SEARCH_LOCATION_SECTORS_WITH_ENVIRONMENTS_AND_EQUIPMENTS_QUERY, UPDATE_LOCATION_SECTOR_MUTATION } from './location-sectors.query';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var LocationSectorApi = /** @class */ (function () {
    function LocationSectorApi(apollo) {
        this.apollo = apollo;
    }
    LocationSectorApi.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: GET_LOCATION_SECTOR_QUERY,
                        variables: { id: id },
                    })
                        .pipe(map(function (response) { return response.data && response.data.locationSector; })).toPromise()];
            });
        });
    };
    LocationSectorApi.prototype.search = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: SEARCH_LOCATION_SECTORS_QUERY,
                        variables: params,
                    }).pipe(map(function (response) { return response.data && response.data.locationSectors; })).toPromise()];
            });
        });
    };
    LocationSectorApi.prototype.create = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: CREATE_LOCATION_SECTOR_MUTATION,
                        variables: { input: params },
                    }).pipe(map(function (response) { return response.data && response.data.createLocationSector; })).toPromise()];
            });
        });
    };
    LocationSectorApi.prototype.update = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: UPDATE_LOCATION_SECTOR_MUTATION,
                        variables: { input: params },
                    }).pipe(map(function (response) { return response.data && response.data.updateLocationSector; })).toPromise()];
            });
        });
    };
    LocationSectorApi.prototype.archive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: UPDATE_LOCATION_SECTOR_MUTATION,
                        variables: { input: params },
                    }).pipe(map(function (response) { return response.data && response.data.updateLocationSector; })).toPromise()];
            });
        });
    };
    LocationSectorApi.prototype.unarchive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: UPDATE_LOCATION_SECTOR_MUTATION,
                        variables: { input: params },
                    }).pipe(map(function (response) { return response.data && response.data.updateLocationSector; })).toPromise()];
            });
        });
    };
    LocationSectorApi.prototype.searchWithEnvironmentsAndEquipments = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: SEARCH_LOCATION_SECTORS_WITH_ENVIRONMENTS_AND_EQUIPMENTS_QUERY,
                        variables: params,
                    }).pipe(map(function (response) { return response.data && response.data.locationSectors; })).toPromise()];
            });
        });
    };
    LocationSectorApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationSectorApi_Factory() { return new LocationSectorApi(i0.ɵɵinject(i1.Apollo)); }, token: LocationSectorApi, providedIn: "root" });
    return LocationSectorApi;
}());
export { LocationSectorApi };
